import { Fragment } from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export type OnboardingStepKey = 'register' | 'setup' | 'invite' | 'first-project'
export type OnboardingStepperProps = { currentStep: OnboardingStepKey }

const STEPS: { key: OnboardingStepKey; label: string }[] = [
  { key: 'register', label: 'Bienvenue' },
  { key: 'setup', label: 'Organisation' },
  { key: 'invite', label: 'Équipe' },
  { key: 'first-project', label: 'Premier projet' },
]

export function OnboardingStepper({ currentStep }: OnboardingStepperProps) {
  const currentIndex = STEPS.findIndex((s) => s.key === currentStep)

  return (
    <ol
      className="flex items-start justify-between mb-6 w-full max-w-md mx-auto"
      aria-label="Progression de l'onboarding"
    >
      {STEPS.map((step, index) => {
        const isDone = index < currentIndex
        const isActive = index === currentIndex
        const status = isDone ? 'terminée' : isActive ? 'en cours' : 'à venir'
        return (
          <Fragment key={step.key}>
            <li
              className="flex flex-col items-center text-center min-w-0"
              aria-current={isActive ? 'step' : undefined}
            >
              <div
                className={cn(
                  'h-8 w-8 rounded-full flex items-center justify-center text-sm font-medium',
                  isDone && 'bg-green-600 text-white',
                  isActive && 'bg-primary text-white shadow-md ring-2 ring-primary/20',
                  !isDone && !isActive && 'bg-white border border-gray-300 text-gray-400',
                )}
                aria-label={`Étape ${index + 1} sur ${STEPS.length} : ${step.label} — ${status}`}
              >
                {isDone ? <Check className="h-4 w-4" /> : index + 1}
              </div>
              <span
                aria-hidden="true"
                className={cn(
                  'text-xs mt-1',
                  isDone && 'text-green-700',
                  isActive && 'font-semibold text-primary',
                  !isDone && !isActive && 'text-gray-400',
                )}
              >
                {step.label}
              </span>
            </li>
            {index < STEPS.length - 1 && (
              <li aria-hidden="true" className="flex-1 pt-4 mx-2">
                <div className={cn('h-0.5', isDone ? 'bg-green-600' : 'bg-gray-200')} />
              </li>
            )}
          </Fragment>
        )
      })}
    </ol>
  )
}
